document.addEventListener('DOMContentLoaded', () => {
    const grid    = document.querySelector('.wp-rel-services__grid');
    if (!grid) return;

    const count   = parseInt(grid.dataset.count, 10) || 0;
    const navGroup = document.querySelector('.wp-rel-services__nav-group');
    const prevBtn  = document.querySelector('.wp-rel-services__nav-btn--prev');
    const nextBtn  = document.querySelector('.wp-rel-services__nav-btn--next');

    // Drag-scroll state
    let isDown    = false;
    let startX    = 0;
    let scrollLeft = 0;

    const getCardStep = () => {
        const card = grid.querySelector('.wp-rel-card');
        return card ? card.offsetWidth + 20 : 280;
    };

    const updateNavState = () => {
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = grid.scrollLeft <= 5;
        nextBtn.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 5;
    };

    const initSlider = () => {
        const needsSlider = count > 4 && window.innerWidth >= 992;

        grid.classList.toggle('is-slider', needsSlider);

        if (navGroup) {
            navGroup.style.display = needsSlider ? 'flex' : 'none';
            navGroup.setAttribute('aria-hidden', needsSlider ? 'false' : 'true');
        }

        if (needsSlider) updateNavState();
    };

    // Prev / Next
    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            grid.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            grid.scrollBy({ left: getCardStep(), behavior: 'smooth' });
        });
    }

    // Update button disabled state on scroll
    grid.addEventListener('scroll', updateNavState, { passive: true });

    // Drag-to-scroll (desktop slider only)
    grid.addEventListener('mousedown', (e) => {
        if (!grid.classList.contains('is-slider')) return;
        isDown = true;
        grid.classList.add('is-dragging');
        startX    = e.pageX - grid.offsetLeft;
        scrollLeft = grid.scrollLeft;
    });

    grid.addEventListener('mouseleave', () => {
        isDown = false;
        grid.classList.remove('is-dragging');
    });

    grid.addEventListener('mouseup', () => {
        isDown = false;
        grid.classList.remove('is-dragging');
    });

    grid.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x    = e.pageX - grid.offsetLeft;
        const walk = (x - startX) * 1.5;
        grid.scrollLeft = scrollLeft - walk;
    });

    // Re-evaluate on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initSlider, 150);
    });

    initSlider();
});
